"use strict";
import { Deadline } from "uniswap/src/features/transactions/swap/components/SwapFormSettings/settingsConfigurations/deadline/Deadline/Deadline";
export const DeadlineOverride = {
  ...Deadline,
  renderTitle: (t) => t("swap.deadline.settings.title")
};
